import { render } from "./OurDepartment.vue?vue&type=template&id=5348d8c4"
import script from "./OurDepartment.vue?vue&type=script&lang=js"
export * from "./OurDepartment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__